import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gate for STAFF-only routes (the Dangal, admin). A candidate (audience ===
 * 'candidate') is bounced home BEFORE the staff screen mounts — those screens
 * read internal Firestore collections (tracks/activity/peer users) that the
 * security rules deny candidates, so rendering them would be both wrong-audience
 * and broken. Stacks inside <RequireAuth>, so loading/isAuthorized are already
 * settled. UX gate only — the server re-enforces on every request.
 */
export default function RequireStaff({ children }: { children: ReactNode }) {
  const { user, loading, isAuthorized, audience } = useAuth();

  const spinner = (label: string) => (
    <div className="flex min-h-screen items-center justify-center bg-paper-50 text-ink-500 dark:bg-clay-floor dark:text-paper-200">
      <span className="animate-pulse">{label}</span>
    </div>
  );

  if (loading) return spinner('Loading…');
  if (!user || isAuthorized !== true) return <Navigate to="/" replace />;
  if (audience !== 'staff') return <Navigate to="/" replace />;
  return <>{children}</>;
}
